import { OrgNodeType } from './org-node-type';

export class OrgNode{

    constructor(orgNodeId:string = null, name:string = null, description:string = null, orgNodeTypeId:number = null, parentOrgNodeId:string = null, rotaryOrganizationId:string = null, importKey:string = null, clubCount:number = 0, memberCount:number = 0){
        this.OrgNodeId = orgNodeId;
        this.Name = name;
        this.Description = description;
        this.OrgNodeTypeId = orgNodeTypeId;
        this.ParentOrgNodeId = parentOrgNodeId;
        this.RotaryOrganizationId = rotaryOrganizationId;
        this.ImportKey = importKey;
        this.ClubCount = clubCount;
        this.MemberCount = memberCount;
    }

    public OrgNodeId:string;
    public Name:string;
    public Description:string;
    public OrgNodeTypeId:number;
    public ParentOrgNodeId:string;
    public RotaryOrganizationId:string;
    public ImportKey:string;
    public ClubCount:number;
    public MemberCount:number;

    public OrgNodeType:OrgNodeType;
    public ParentOrgNode:OrgNode;

    public static readonly GLOBAL:OrgNode = new OrgNode("00000000-0000-0000-0000-000000000000", "Global", "", OrgNodeType.ROOT);
    public static readonly ALL_ZONES:OrgNode = new OrgNode("00000000-0000-0000-0000-000000000001", "All Zones", "", OrgNodeType.ZONE);
    public static readonly ALL_DISTRICTS:OrgNode = new OrgNode("00000000-0000-0000-0000-000000000002", "All Districts", "", OrgNodeType.DISTRICT);
    public static readonly ALL_CLUB_GROUPS:OrgNode = new OrgNode("00000000-0000-0000-0000-000000000003", "All Club Groups", "", OrgNodeType.CLUBGROUPING);
    public static readonly ALL_CLUBS:OrgNode = new OrgNode("00000000-0000-0000-0000-000000000004", "All Clubs", "", OrgNodeType.ROTARYCLUB);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/entities/org-node.ts